import { SVGProps } from "react"

type Props = {
  hovered?: boolean
  size?: number
} & SVGProps<SVGSVGElement>

export const IconNavion = ({ hovered, size = 22, ...props }: Props) => {
  if (hovered)
    return <IconNavionHovered {...props} width={size} height={size} />
  else return <IconNavionDefault {...props} />
}

const IconNavionHovered = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="a"
    data-name="Calque 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 10 8"
    // width={size}
    // height={size}
    {...props}
  >
    <path
      fill="#4b5563"
      stroke="#fff"
      strokeMiterlimit={10}
      strokeWidth={0.3}
      d="m8.66.89c-.08-.06-.2-.08-.3-.04L1.13,3.76c-.18.07-.29.24-.28.42.01.18.14.34.33.39l2.7.75.08,1.34c0,.17.13.31.3.37.05.02.1.02.15.02.12,0,.25-.05.33-.14l.67-.68,1.31.84c.08.05.17.08.27.08.06,0,.12,0,.17-.03.15-.05.26-.17.29-.31l1.3-5.66c.02-.1-.02-.2-.1-.27Zm-1.37.98l-3.2,2.95-2.44-.68L7.29,1.87Zm-2.76,4.48l-.04-.69.44.28-.4.41Zm2.39.21l-2.3-1.47,3.34-3.08-1.04,4.55Z"
    />
  </svg>
)

const IconNavionDefault = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="a"
    data-name="Calque 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 10 8"
    width={22}
    height={22}
    {...props}
  >
    <path
      fill="#4b5563"
      stroke="#fff"
      strokeMiterlimit={10}
      strokeWidth={0.3}
      d="m8.66.89c-.08-.06-.2-.08-.3-.04L1.13,3.76c-.18.07-.29.24-.28.42.01.18.14.34.33.39l2.7.75.08,1.34c0,.17.13.31.3.37.05.02.1.02.15.02.12,0,.25-.05.33-.14l.67-.68,1.31.84c.08.05.17.08.27.08.06,0,.12,0,.17-.03.15-.05.26-.17.29-.31l1.3-5.66c.02-.1-.02-.2-.1-.27Zm-1.37.98l-3.2,2.95-2.44-.68L7.29,1.87Zm-2.76,4.48l-.04-.69.44.28-.4.41Zm2.39.21l-2.3-1.47,3.34-3.08-1.04,4.55Z"
    />
  </svg>
)
